import React, { useState, useRef } from 'react'
import Icon from '../../cpn/Icon';
import { useCsvFileMutation } from '../../store/DianShangYeWuApi';
import { Form,  Modal, App, Space } from 'antd';
function ClientAddMulti(props) {
    const {message} = App.useApp();
    const [open,setOpen] = useState(false)
    const [form] = Form.useForm();
    const [submit] = useCsvFileMutation();
    const [selectedFile, setSelectedFile] = useState(null);
    const fileInputRef = useRef(null);
    
    const handleOpen = () => {
        // 清除已有的文件选择
        setSelectedFile(null);
        form.resetFields();
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
        setOpen(true);
    };
    
    const handleUpload = () => {
        if (!selectedFile) {
            message.warning('请先选择CSV文件');
            return;
        }
        
        // 构造 FormData 用于 multipart/form-data 上传，与 Apifox 格式一致
        const formData = new FormData();
        formData.append('kh_qy_id', props.qy_id);
        formData.append('kh_qy_name', props.qy_name);
        formData.append('kh_cid', props.yh_id);
        formData.append('kh_cname', props.yh_name);
        formData.append('kh_file', selectedFile);

        submit(formData).then((res) => {
            if (res.data && res.data.Status === 'success') {
                message.success('批量新增成功');
                setOpen(false);
                setSelectedFile(null);
                form.resetFields();
                if (fileInputRef.current) {
                    fileInputRef.current.value = '';
                }
            } else {
                message.error('批量新增失败：' + (res.data ? res.data.Message : '未知错误'));
            }
        }).catch((error) => {
            message.error('上传失败：' + (error.message || '网络错误'));
        });
    };

    return (
        <>
            <Icon type='addMulti' onClick={handleOpen} title='批量新增客户' />
            <Modal
                open={open}
                title='批量新增客户'
                width={800}
                onCancel={() => {
                    setOpen(false);
                    setSelectedFile(null);
                    form.resetFields();
                    if (fileInputRef.current) {
                        fileInputRef.current.value = '';
                    }
                }}
                onOk={handleUpload}
            >
                <Form form={form}>
                    <Form.Item>
                        <Space direction='vertical'>
                            <div>第一步：点击链接下载模板：<a href="/img/批量新增客户信息表.csv" target="_blank">下载模板</a></div>
                            <div>第二步：填入客户类型（必填且和软件客户类型一致）、客户名称（必填）、备注（选填）</div>
                            <div>第三步：保存为UTF-8编码的CSV文件</div>
                            <div></div>
                        </Space>
                    </Form.Item>
                    <Form.Item
                        label="第四步：请选择CSV文件"
                        style={{ marginBottom: 0, width: '100%' }}
                    >
                        <input
                            ref={fileInputRef}
                            type="file"
                            accept=".csv"
                            style={{ width: '100%' }}
                            onChange={e => {
                                const file = e.target.files[0];
                                setSelectedFile(file || null);
                            }}
                        />
                    </Form.Item>
                </Form>
            </Modal>
        </>
    )
}

export default ClientAddMulti